// src/App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';
import { CartService } from './services/cartService';
import CartDrawer from './components/CartDrawer';
import { ROUTES } from './constants';
import ProtectedRoute from './components/ProtectedRoute';
import { ToastContainer } from 'react-toastify';

// Pages
import HomePage from './pages/ecommerce/home-page/HomePage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import AdminLayout from './pages/admin/AdminLayout';
import ProductsPage from './pages/admin/ProductsPage';
import Dashboard from './pages/admin/Dashboard';
import OrdersPage from './pages/admin/OrdersPage';
import CustomersPage from './pages/admin/CustomersPage';
import SettingsPage from './pages/admin/SettingsPage';
import FacebookLeadsPage from './pages/admin/facebook-leads/FacebookLeadsPage';
import AddProductPage from './pages/admin/AddProductPage';
import EditProductPage from './pages/admin/EditProduct';
import OrderDetailPage from './pages/admin/OrderDetailPage';
import VariantsPage from './pages/admin/VariantsPage';
import BrandsPage from './pages/admin/BrandsPage';
import SuppliersPage from './pages/admin/SuppliersPage';
import TvaPage from './pages/admin/TvaPage';
import DepotsPage from './pages/admin/DepotsPage';
import StocksPage from './pages/admin/StocksPage';
import CaissePage from './pages/admin/CaissePage';
import CaissesListPage from './pages/admin/CaissesListPage';
import CaisseChiffreAffairePage from './pages/admin/CaisseChiffreAffairePage';
import StockTransfersPage from './pages/admin/StockTransfersPage';
import AddOrder from './pages/admin/new-order-components/AddOrder';
import EditOrder from './pages/admin/edit-order-components/EditOrder';
import Platform from './pages/admin/platform/platform';
import Purchase from './pages/admin/purchase/Purchase';
import PurchasesList from './pages/admin/purchase/PurchasesList';
import EditPurchase from './pages/admin/purchase/EditPurchase';
import ReglementFournisseurPage from './pages/admin/ReglementFournisseurPage';
import ConsommationFournisseurPage from './pages/admin/ConsommationFournisseurPage';
import ProductPage from './pages/ecommerce/product/ProductPage';
import Catalog from './pages/ecommerce/catalog/Catalog';
import OrderConfirmation from './pages/ecommerce/order/OrderConfirmation'; // Add this line
import CheckoutPage from './pages/ecommerce/checkout/CheckoutPage'; // Import CheckoutPage
// New Exchange Pages
import ExchangesPage from './pages/admin/exchanges/ExchangesPage';
import AddExchange from './pages/admin/exchanges/AddExchange';
import EditExchange from './pages/admin/exchanges/EditExchange'; // Import EditExchange
import RetourRecuPage from './pages/admin/retour-recu/RetourRecuPage';
// import ExchangeDetail from './pages/admin/exchanges/ExchangeDetail';
import ImportPage from './pages/admin/import/ImportPage'; // Import the new ImportPage
import PromoCodePage from './pages/admin/promocodes/PromoCodePage'; // Import PromoCodePage
import ChargesPage from './pages/admin/charges/ChargesPage'; // Import ChargesPage
import RemisePage from './pages/admin/remises/RemisePage';
import ClientsPage from './pages/admin/clients/ClientsPage';
import CouponsPage from './pages/admin/coupons/CouponsPage';
import BarcodeVerificationPage from './pages/BarcodeVerificationPage'; // Import BarcodeVerificationPage
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from './components/ErrorBoundary';
import PermissionsPage from './pages/admin/PermissionsPage';
import { PermissionedRoute } from './components/PermissionRoute';
import { usePermissionViewModel } from './pages/admin/permissions/viewmodel/permission-viewmodel';
import { isAdmin,isAuthenticated } from './login/controller/login-controller';
import { renderRoutesWithPermissions } from './components/renderRoutesWithPermissions';
import RedirectToFirstAccessibleRoute from './components/RedirectToFirstAccessibleRoute';
const App = () => {
  useEffect(() => {
    // Load cart data from localStorage on app initialization
    CartService.loadCart();
  }, []);


  const { hasPermission } = usePermissionViewModel();
  const admin = isAdmin()
  const isAuth = isAuthenticated()


   const adminRoutes = [
    {
      path: '', // dashboard index
      element: <Dashboard />,
      menuName: 'tableau_de_board',
      action:'read'

    },
    {
      path: 'products',
      element: <ProductsPage />,
      menuName: 'produit',
      action:['read','write']

    },
    {
      path: 'variants',
      element: <VariantsPage />,
      menuName: 'variante',
      action:['read','write']

    },
    {
      path: 'brands',
      element: <BrandsPage />,
      menuName: 'marque',
      action:['read','write']
    },
    {
      path: 'suppliers',
      element: <SuppliersPage />,
      menuName: 'fournisseur',
      action:['read','write']

    },
{    path: 'products/new/',
    element: <AddProductPage />,
    menuName: 'produit',
    action:'write'
},
{    path: 'products/:id/edit',
  element: <EditProductPage />,
  menuName: 'produit',
  action:'edit'
},
{    path: 'tva',
  element: <TvaPage />,
  menuName: 'tva',
  action:'read'
},
{    path: 'depots',
  element: <DepotsPage />,
  menuName: 'depot',
  action:['read','write']
},
{    path: 'stocks',
  element: <StocksPage />,
  menuName: 'stock',
  action:['read','write']
},
{    path: 'stock-transfers',
  element: <StockTransfersPage />,
  menuName: 'transfert',
  action:['read','write']
},
{    path: 'caisse',
  element: <CaissePage />,
  menuName: 'caisse',
  action:['read','write']
},
{    path: 'caisses',
  element: <CaissesListPage />,
  menuName: 'liste_caisses',
  action:['read','write']
},
{    path: 'caisses/chiffre-affaires',
  element: <CaisseChiffreAffairePage />,
  menuName: 'chiffre_affaires_caisse',
  action:'read'
},
{    path: 'orders/:id/edit',
  element: <EditOrder />,
  menuName: 'commande',
  action:'edit'
},
{    path: 'orders/new',
  element: <AddOrder />,
  menuName: 'commande',
  action:'write'
},
{    path: 'orders/:id',
  element: <OrderDetailPage />,
  menuName: 'commande',
  action:'readOne'
},
{    path: 'purchases',
  element: <PurchasesList />,
  menuName: 'achat',
  action:['read','write']
},
{    path: 'purchases/new',
  element: <Purchase />,
  menuName: 'achat',
  action:'write'
},
{    path: 'purchases/:id',
  element: <EditPurchase />,
  menuName: 'achat',
  action:'edit'
},
{    path: 'reglement-fournisseur',
  element: <ReglementFournisseurPage />,
  menuName: 'reglement_fournisseur',
  action:['read','write']
},
{    path: 'consommation-fournisseur',
  element: <ConsommationFournisseurPage />,
  menuName: 'consommation_fournisseur',
  action:['read']
},
{    path: 'orders',
  element: <OrdersPage />,
  menuName: 'commande',
  action:['read','write']
},
{    path: 'platform',
  element: <Platform />,
  menuName: 'platforme',
  action:['read','write']
},
{    path: 'exchanges',
  element: <ExchangesPage />,
  menuName: 'echange',
  action:['read','write']
},
{    path: 'exchanges/add',
  element: <AddExchange />,
  menuName: 'echange',
  action:'write'
},
{    path: 'exchanges/:id/edit',
  element: <EditExchange />,
  menuName: 'echange',
  action:'edit'
},
{    path: 'retour-recu',
  element: <RetourRecuPage />,
  menuName: 'retour_recu',
  action:['read','write']
},
{    path: 'import',
  element: <ImportPage />,
  menuName: 'import_de_contacts',
  action:'write'
},
{    path: 'promocodes',
  element: <PromoCodePage />,
  menuName: 'code_promotionnel',
  action:['read','write']
},
{    path: 'charges',
  element: <ChargesPage />,
  menuName: 'charges',
  action:['read','write']
},
{    path: 'remises',
  element: <RemisePage />,
  menuName: 'remises',
  action:['read','write']
},
{    path: 'coupons',
  element: <CouponsPage />,
  menuName: 'coupons',
  action:['read','write']
},
{    path: 'clients',
  element: <ClientsPage />,
  menuName: 'clients',
  action:['read','write']
},
{    path: 'customers',
  element: <CustomersPage />,
},
{    path: 'settings',
  element: <SettingsPage />,
  menuName: 'paramètres',
  action:['read','write']
},
{    path: 'facebook-leads',
  element: <FacebookLeadsPage />,
  menuName: 'facebook_leads',
  action:['read','write']
},

{    path: 'permissions',
  element: <PermissionsPage />,
},

  ];







  return (
    <RecoilRoot>
      <RecoilNexus />
      <ErrorBoundary>
      <Router>
      {/* {isAuth&&<AdminLayout /> } */}
        {/* CartDrawer should be outside of Routes but inside Router */}
        <CartDrawer />

        <Routes>
          {/* Public routes */}
          <Route path={ROUTES.home} element={<HomePage />} />
          <Route path={ROUTES.login} element={<Login />} />
          <Route path={ROUTES.signup} element={<Signup />} />
          <Route path="/product/:id/:platformid" element={<ProductPage />} />
          <Route path="/product/:id/:platformid/:depotid" element={<ProductPage />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} /> {/* Add this route */}
          <Route path="/checkout" element={<CheckoutPage />} /> {/* Add Checkout route */}
          <Route path="/barcode-verification" element={<BarcodeVerificationPage />} /> {/* Add this line */}

          {/* Protected admin routes */}
          <Route element={<ProtectedRoute adminOnly={true} adminRoutes={adminRoutes}/>}>
            <Route path={ROUTES.admin} element={<AdminLayout />}>
        { renderRoutesWithPermissions(adminRoutes) }

      {/* <Route index element={<RedirectToFirstAccessibleRoute adminRoutes={adminRoutes}/>} /> */}
              </Route>
            </Route>

          {/* Fallback route */}
          <Route path="*" element={<Navigate to={ROUTES.home} />} />
        </Routes>
        {/* ToastContainer should be here, outside Routes but inside Router */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Router>
      </ErrorBoundary>
    </RecoilRoot>
  );
};


export default App;
